import { Component, computed, input, output, signal } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { AgentQuickReplies } from 'insight/src/app/shared/agent/ui/agent-quick-replies/agent-quick-replies';
import { EnumOption, InputRequestedPayload } from 'app/shared/models/agent.model';
import { FormaButton, FormaChips } from 'forma';

/**
 * Forma-styled widget for a RequiresInput tool call, used by the Story chat.
 *
 * - Enum  → quick-reply chips (submits on click); "Other…" reveals free text
 * - Bool  → Yes / No buttons (submit on click)
 * - Text / Number / Date → field + Submit button
 *
 * Plus inline validation error display.
 */
@Component({
  selector: 'app-agent-input-request',
  imports: [TranslocoPipe, FormaButton, FormaChips, AgentQuickReplies],
  host: { class: 'agent-input-request' },
  templateUrl: './agent-input-request.html',
  styleUrls: ['./agent-input-request.scss'],
})
export class AgentInputRequest {
  readonly payload = input.required<InputRequestedPayload>();
  readonly validationError = input<string | null>(null);
  readonly otherLabel = input<string>('Other…');

  readonly submitted = output<string>();
  readonly skipped = output<void>();

  protected readonly textValue = signal('');
  protected readonly showFreeText = signal(false);

  protected readonly canSubmit = computed(() => this.textValue().trim().length > 0);

  protected onText(event: Event): void {
    this.textValue.set((event.target as HTMLInputElement).value);
  }

  protected onEnumSelect(option: EnumOption): void {
    this.submitted.emit(option.key);
  }

  protected submit(): void {
    if (!this.canSubmit()) {
      return;
    }
    this.submitted.emit(this.textValue());
  }
}
